import get from 'lodash-es/get'
import { ThunkAction } from 'redux-thunk'

import { getSimilarItems } from '../utils/getSimilarItems'
import { getCurrentSiteDomain } from '../utils/sites'

import {
  IGetSimilarItemsFailAction,
  IGetSimilarItemsSuccessAction,
  TypeKeys
} from './searchPage'

import { IRootState } from '../../common/reducers'

/**
 * fetch similar items
 */
export const fetchSimilarItems = (
  itemID: number
): ThunkAction<
  Promise<IGetSimilarItemsSuccessAction | IGetSimilarItemsFailAction>,
  IRootState,
  void
> => {
  return (dispatch, getState) => {
    const similarItems = get(getState(), 'searchPage.similarItems')
    const errorOccured = !!(similarItems[itemID] && similarItems[itemID].error)

    const siteName = get(getState(), 'common.currentSite')
    const site = getCurrentSiteDomain(siteName)

    if (!similarItems[itemID] || errorOccured) {
      return getSimilarItems(itemID, site)
        .then(similarItemsData => {
          return dispatch(
            fetchSimilarItemsSuccess({ itemID, similarItems: similarItemsData })
          )
        })
        .catch(error => {
          return dispatch(fetchSimilarItemsFailure(itemID, error.message))
        })
    } else {
      return Promise.resolve(
        dispatch(
          fetchSimilarItemsSuccess({
            itemID,
            similarItems: similarItems[itemID]
          })
        )
      )
    }
  }
}

const fetchSimilarItemsSuccess = ({
  itemID,
  similarItems
}: {
  itemID: number
  similarItems: any
}) => {
  const action: IGetSimilarItemsSuccessAction = {
    type: TypeKeys.GET_SIMILAR_ITEMS_SUCCESS,
    payload: { itemID, similarItems }
  }
  return action
}

const fetchSimilarItemsFailure = (itemID: number, error: string) => {
  const action: IGetSimilarItemsFailAction = {
    type: TypeKeys.GET_SIMILAR_ITEMS_FAIL,
    payload: { itemID, error }
  }
  return action
}

export default fetchSimilarItems
